(function($){ 
  // THESE ARE INITIALISATIONS AND OPTIONS FOR THE PRODUCT TEMPLATE GALLERY ONLY
  theme.Product();

  /* SLICK SLIDER SWITH BASED ON VARIANTS */
  $('.product-single__thumbnails .product-single__photos--thumbnail').each(function(index){
    var thisID = $(this).data('id');

    slickIndex.push(thisID);
  });
  
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    autoplay: false
  });


  // THIS IS A HELPER FOR OPTIONS SELECTION
  $('.single-option-selector').each(function(){
    $(this).on('change', function(e){
      // This will trigger every time someone changes a select box
      // Selected variant is set to data-variant, this is controlled in theme.js.liquid
      // Helpers
      var selectorID    = $(this).prop('id')
      ,   selectorClass = $(this).prop('class')
      ,   selectorData  = $(this).data('index')
      ,   selectorVal   = $(this).val();

    });
  });
})(jQuery);